(function (angular, _) {
  "use strict";

  angular
    .module("GorillaBoy.DocumentViewer")
    .controller("QuartzDocumentController", [
      "$scope",
      "$routeParams",
      "$log",
      "$location",
      "$rootScope",
      "$q",
      '$translate',
      "Anonymous",
      "userInfo",
      "FeatureManagerService",
      "Features",
      "ClientMetricsService",
      'AppConstants',
      'EndpointConfig',
      QuartzDocumentController,
    ]);

  function QuartzDocumentController(
    $scope,
    $routeParams,
    $log,
    $location,
    $rootScope,
    $q,
    $translate,
    Anonymous,
    userInfo,
    FeatureManagerService,
    Features,
    ClientMetricsService,
    AppConstants,
    EndpointConfig
  ) {

    activate();

    /**
     * Main function that gets invoked when this controller is activated.
     */
    function activate() {
      $log.debug(
        new Date().toISOString() + " [QuartzDocumentController] Initiating…"
      );

      $scope.isQuartzEnabledForSite = FeatureManagerService.isFeatureEnabled(Features.UI.QUARTZ_ENABLED);
      
      $scope.isQuartzEnabledForUser = function() {
        if (FeatureManagerService.isFeatureEnabled(Features.UI.QUARTZ_KILL_SWITCH)) {
            return false;
        }
        if (!FeatureManagerService.isFeatureEnabled(Features.UI.QUARTZ_ENABLED)) {
            return false;
        }
        if (FeatureManagerService.isFeatureEnabled(Features.UI.QUARTZ_ENABLED_AWS) && EndpointConfig.isAmazonSite() && $rootScope.isMemberOfGroup(AppConstants.NovaOnboardingGroups.ALL_AWS_EMPLOYEES)) {
            return true;
        }
        return FeatureManagerService.isFeatureEnabled(Features.UI.QUARTZ_ENABLED_AMAZON_CORP_SITE) || $rootScope.isMemberOfGroup(AppConstants.NovaOnboardingGroups.NOVA_QUARTZ_USERS);
    };

      $scope.quartzDocumentId = $routeParams.documentId;
      $scope.novaPreviewSignupMsg = $translate.instant('QUARTZ_DOC_NOVA_SIGNUP_MSG_PART1');

      // SECTION: Layout code
      $scope.layout = {
        partialContent: "./document-viewer/quartz_content_partial.html",
        view: "QUARTZ",
        showLeftSidebar: $rootScope.showLeftSidebar,
        hasRightSidebar: false,
        showRightSidebar: false,
        showUploadPane: false,
        showFilterPanel: false,
        isAnonymous: Anonymous,
      };

      $scope.userInfo = $scope.user = userInfo;
      ClientMetricsService.addPageViewWithDocIdToSession('NOVA_INVITATION_FOR_QUARTZ', $scope.quartzDocumentId);
    }
  }
})(angular, _);
